export const en = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'Add Text',
  ADD_A_PROMPT: 'Search photo by AI',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'Add to Cart',
  ADD_TEMPLATE: 'Add Template',
  ADJUST_SIZE_KEY: ' Adjust Size',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  ADOBE_STOCK_TITLE_KEY: 'Adobe Stock',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  AI: 'AI',
  ALIGN_BOTTOM_KEY: 'Align Bottom',
  ALIGN_CENTER_KEY: 'Align Center',
  ALIGN_KEY: 'Align',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'Align Middle',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Align Top',
  ALL_TAB_TITLE_KEY: 'All',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',

  BASIC_HELPER_INSTRUCTION1_KEY:
    'Browse the content and select the images for your design, or upload your own',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Preview your design, or fine-tune the details',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Customize the design and add other elements to your project',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'When the design is ready, click NEXT to make a final check and place your order.',
  BACK_KEY: 'Back',
  BACKGROUND_KEY: 'Background',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY: 'No Inspirations found under this category',
  BRING_TO_FRONT_KEY: 'Bring To Front',

  CANCEL_TEXT_KEY: 'Cancel',
  CENTIMETERS_KEY: 'centimeters',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Choose File',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Clear All',
  CLEAR_COLOR_KEY: 'Clear Color',
  CLOSE_WINDOW_KEY: 'Close window',
  CLEAR_ALL_OBJECTS: 'Clear all objects',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'This will remove all objects from your background.',
  CLEAR_DESIGN_KEY: 'Clear design',
  CLICK_ON_WALL: 'Click on the wall you want to add',
  COLOR_KEY: 'Color',
  CONTINUE_KEY: 'Continue...',
  CONTINUE_PURCHASING: 'Continue purchasing',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Create new',
  CREATE_A_PROJECT: 'Create a project',

  DESIGN_KEY: 'Design',
  DELETE_KEY: 'Delete',
  DEVICE: 'Device',
  DOCUMENT_COLORS: 'Document Colors',
  DONE: 'Done!',
  DONE_KEY: 'Done',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'Download',
  DOWNLOAD_APP_TITLE_KEY: 'You can download the App here:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'DownloadHP SmartStream ',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox Import',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DROPBOX_IMPORT_ERROR_HEADER: 'There was a problem importing some files',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime search',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime images',
  DUPLICATE_KEY: 'Duplicate',

  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Edit Design',
  EDIT_LOWERCASE_KEY: 'edit',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    "We're sorry, there was an error. Please try again later.",
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Oops, there was an error in opening the uploaded PDF file.',
  EMAIL_KEY: 'Email',
  EMAIL_ADDRESS_KEY: 'Email Address:',
  EMAIL_CHECKBOX_MESSAGE:
    'I know this person understands that will be receiving emails from HP on behalf of me or this service provider.',
  EXTRA_INFO_KEY: 'Extra info',
  SERIAL_NUMBER_KEY: 'Serial number',
  EMAIL_NOTIFICATION:
    'An email will be sent shortly. Please allow up to 15 minutes for processing.',
  EMAIL_DIALOG_MESSAGE:
    'Type in the email address of the person you want to share your design with.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Existing Folder',

  FACEBOOK_KEY: 'Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    "Double check you're happy with your design before proceeding to checkout.",
  FINAL_CHECK_TITLE_KEY: 'Final Check',
  FINISH_KEY: 'Finish',
  FINISHING_KEY: 'Finishing',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Flip',
  FOR_KEY: 'for',
  FORGOT_PASSWORD_KEY: 'Forgot password ?',
  FOTOLIA_KEYWORDS_KEY: 'Keywords:',
  FOLDER_NAME: 'Folder Name',
  FOLDER_NAME_KEY: 'Folder Name:',
  FOLDER_ALREADY_EXIST_KEY: 'This folder name already exists',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',

  GENERATE_BY_AI: 'Generate by AI',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, I got it',
  GROUP_ALL_KEY: 'Group All',
  GROUP_SCALE: 'Group Scale', //  new
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Give your project a name',

  HEIGHT_KEY: 'Height',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',
  HELP_KEY: 'Help',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',

  IMAGES_TITLE_KEY: 'IMAGES',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Importing',
  INCHES_COLUMN_HEADER_KEY: 'Inches',
  INCHES_KEY: 'inches',
  INCHES_UNIT_STRING_KEY: 'in.',
  INFORMATION: 'Information',
  INVALID_EMAIL_ADDRESS_KEY: 'Invalid Email Address',
  INVALID_INFO_KEY: 'Please enter details.',
  INVALID_NAME_KEY: 'Invalid Name',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Sorry, but the file you selected is too large. The max file size is 500mb.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    ' Oops, that is not a valid file format. We can only handle pdf,jpg, png, svg and tif.',

  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Language',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Learn more',
  LEARN_THE_BASICS_KEY: 'Learn the basics',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'By using this site you agree to be bounded by these',
  LEGAL_FOOTER_MESSAGE2_KEY: 'This website complies with the',
  LEGAL_FOOTER_MESSAGE3_KEY: 'and the',
  LENGTH_STRING_IN_INCHES_KEY: 'in',
  LINKED_IN_KEY: 'LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'To visualize the content you are adding, please download the LinkReader app.',
  LOADING_KEY: 'Loading...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Lock',
  LOGIN_KEY: 'Login',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Login to Dreamstime',
  LOGIN_ADOBE_STOCK_KEY: 'Login to Adobe Stock',
  LOGOUT_KEY: 'Logout',

  MATERIAL_TITLE_KEY: 'MATERIAL',
  MATERIAL_STRING_KEY: 'Material',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'This background cannot be scaled down further as you have reached the minimum height or width required to cover your wall.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Model',
  MORE_INFO_TEXT_KEY: 'More info',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT: 'Sorry, multi-page PDFs are not supported.',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  NAME_KEY: 'Name:',
  NEXT_BUTTON_TITLE_KEY: 'NEXT',
  NEW_FOLDER_KEY: 'New Folder',
  NO_SHADOW_KEY: 'No Shadow',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'This project name already exists',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'This folder name already exists',

  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Order Sample',
  ORDER_SAMPLE: 'Order a sample',
  ORDER_SAMPLE_INFOLABEL_1:
    'Select the piece of the image you want to order as a sample',
  ORDER_SAMPLE_INFOLABEL_2:
    'You will receive an email with a close-up view of your project at actual size',
  ORDER_SAMPLE_INFOLABEL_3:
    'This will help you to evaluate its quality and resolution',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Order Sample Now',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Receive an email containing a close-up view of your project at actual size to evaluate its quality/resolution.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',

  PASSWORD_KEY: 'Password',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'I own the copyright to this image and agree to the',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'Pixel',
  PININTEREST_KEY: 'Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'i.e Some important things you need to communicate to the print shop',
  PLACEHOLDER_INCHES_STRING_KEY: 'in',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'Poster',
  PLEASE_CHOSE_VARIANT: 'Please choose the variant of the product',
  PLEASE_SELECT_WALL_COVERING_SIZE: 'Please select Wall Covering size',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Position',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Save your project',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Your project has changes that need to be saved before you continue.',
  PRICE_COLUMN_HEADER_KEY: 'Price',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'Processing...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Preview',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Project Name',
  PROJECT_NAME: 'Project Name:',
  PROJECT_ALREADY_EXIST_KEY: 'This project name already exists',
  PIXELATION_WARNING_KEY: 'Pixelation Warning',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Due to the resolution of your uploaded image, your skin may be blurred or distorted. To ensure there is no blur, please upload an image with a good quality and avoid stretching the image. If you are happy with the preview and would like to proceed, please continue to submit.',
  PROCESSING_FAILED: 'Processing failed, please try after some time',

  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer, ',
  REQUIRED_FIELDS_KEY: '*Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'REQUIRED',
  RECOLOR_KEY: 'Recolor',
  RECOLORING_KEY: 'Recoloring...',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Recolor',
  REQUEST_SAMPLE_KEY: 'Request a sample',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  RESULT: 'Result',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Request for Quotation',
  RIGHT_LOGO_TEXT_KEY: 'by',
  ROTATE_KEY: 'Rotate',
  ROTATE_LEFT_KEY: 'Rotate 90° Left',
  ROTATE_RIGHT_KEY: 'Rotate 90° Right',
  ROTATION_KEY: 'Angle rotation',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Rows and Columns',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',

  SALUTATION: 'Salutation',
  SAVE_KEY: 'Save',
  SAVING_KEY: 'Saving...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Save template',
  SAVE_DIALOG_TITLE: 'Save your project',
  SAVE_PROJECT_NAME_KEY: 'Save your project first',
  SAVEDIALOG_MESSAGE:
    "Please login to save your project.If you do not have an account, we'll help you create one. Your progress will not be lost.",
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'Scale',
  SCALE_ALL_KEY: 'Scale All',
  SCALE_TO_FILL_KEY: 'Scale To Fill',
  SEARCH_BUTTON_TITLE_KEY: 'Search',
  SELECT_CUSTOM_SIZE_KEY: 'Select custom size',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'Search',
  SEARCH_PHOTO_BY_AI: 'Search photo by AI',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_APP_SIZE_KEY: 'Select {0} size',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Send me installation instructions',
  SEND_TO_BACK_KEY: 'Send To Back',
  SEND_KEY: 'Send',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Set Size',
  SETTINGS_KEY: 'Settings',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'Share',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'sq. ft.',
  SQM_UNIT_STRING_KEY: 'm²',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'Submit',
  SHARE_LINK_LABEL: 'Select the type of link you want to share',
  SHARE_EDIT_LINK: 'Edit link',
  SHARE_VIEW_LINK: 'View link',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',

  TARGET_VIEWING_HINT:
    '* Target viewing distance can be changed from settings.',
  TERMS1_KEY: 'terms',
  TERMS2_KEY: 'HP Privacy statement',
  TERMS3_KEY: 'HP Personal Data Rights Notice',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'Terms of Use.',
  TEXT_ALIGNMENT: 'Text alignment',
  TEXT_LAYOUT: 'Text layout',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Tile',
  TOTAL_KEY: 'TOTAL',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Opacity',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Thank You',
  TWITTER_KEY: 'Twitter',

  UNLOCK_KEY: 'Unlock',
  UNGROUP_KEY: 'Ungroup',
  UPDATE_TEXT_KEY: 'Update',
  UPLOAD_KEY: 'Upload',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'User Name',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Untile',
  UNTITLED_DESIGN: 'Untitled design- ',
  UNSPLASH: 'Unsplash',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',

  VALIDITY_KEY: 'Validity',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'VAT',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'View in Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_IN_ADOBE_STOCK_KEY: 'View in Adobe Stock©',
  VIEW_DESIGN_DETAILS_KEY: 'View design details',
  VIEW_DESIGNER_PROFILE_KEY: 'View designer profile',
  VIEW_PRICE_KEY: 'View Price',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',

  WALL_POSTER_KEY: 'Posters',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'Warning',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Width',

  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in',
  YOUR_NAME_KEY: 'Your Name',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'Your project',
  ZOOM_IN_KEY: 'Zoom In',
  ZOOM_OUT_KEY: 'Zoom Out',

  PROJECT_NAME_ERROR_TEXT: 'Please enter a name for your project.',
  PROJECT_FOLDER_ERROR_TEXT: 'Please enter a name for your project folder.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Minimum viewing distance',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'No dreamstime Contents found',
  NO_ELEMENT_ERROR_MESSAGE: 'No element found.',
  NO_MORE_IMAGES_FOUND_KEY: 'No more images found',
  NO_PATTERN_ERROR_MESSAGE: 'No patterns found.',
  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} x {1} resolution image',
  MESSAGE_KEY: 'Message:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    'you will recieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs',
  ZOOM_WARNING_PIXELATED_TEXT:
    "You've scaled to a point where your printed image may look pixelated when viewing at {0} {1} * (current printed resolution is {2} dpi).",
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'The recommended viewing distance would be {0} {1} If this is not appropriate, please decrease the scale of this image or the size of your wall.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Recommended minimum image size should be {0} x {1} pixels.',
  UPLOAD_STATUS: '{0}% of {1}MB',
  REGISTER_TO: 'Register to {0}',

  // retain in English
  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',

  // language names
  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',

  // New String
  MINIMUM_DIMENSIONS_KEY: 'Minimum dimensions are {0} (w) by {1} (h).',
  MINIMUM_HEIGHT_KEY: 'Minimum height is {0}.',
  MINIMUM_WIDTH_KEY: 'Minimum width is {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1} (h).',
  MAXIMUM_WALL_SIZE_KEY: 'Maximum wall size is {0} sq.{1}',
  MAXIMUM_WIDTH_KEY: 'Maximum width is {0}.',
  MAXIMUM_HEIGHT_KEY: 'Maximum height is {0}',
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Please insert numerical dimensions greater than zero.',
  OF_KEY: 'of',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Importing file {0} of {1}',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT: 'Sorry, encrypted PDFs are not supported.',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  PROJECT_VALID_NAME_ERROR_TEXT: 'Please enter a valid name',
  AUTHENTICATE_DIALOG_TITLE: 'This content source is password protected',
  AUTHENTICATE_FAILED_MESSAGE: 'Authentication failed!',
  FEEDBACK_HEADER:
    ' Please feel free to share your feedback on the below questionnaire that we suggest to embed under DesignerV2:',
  NEGATIVE_FEEDBACK_HEADER:
    ' Could you please select the topics which did not meet your expectations:',

  // CANVAS RELATED
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: 'Canvas height exceeds wall height',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'Canvas width exceeds wall width.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY: 'Maximum columns for current width is {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY: 'Maximum rows for current height is {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'Wall width is less than the canvas width',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'Wall should have a minimum width of {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'Wall should have a minimum height of {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Wall height is less than the canvas height.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Maximum wall height is {0} {1}.',

  // feedback strings
  HP_FEEDBACK_TEXT: 'We would love to hear from you',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with us?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/proprietary content",

  // new
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  ADOBE_STOCK_SEARCH_TITLE: 'Adobe Stock Search',
  HP_MOSAIC_SEARCH_TITLE: 'HP mosaic',
  RANDOMIZE_KEY: 'Randomize',
  DEFAULT_PROJECT_NAME: 'Project',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'This Inspiration template comes with a default size of {0} X {1} {2}. Your page size will be automatically changed to fit this template.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Choose your laptop',
  CHOOSE_YOUR_LAPTOP_FAMILY_KEY: 'Choose your laptop family',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'First name',
  LAST_NAME_KEY: 'Last name',
  PHONE_NUMBER_KEY: 'Phone No.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: 'Please enter required fields',
  ADDRESS_KEY: 'Address',
  INVALID_ADDRESS_KEY: 'Invalid address',
  CITY_KEY: 'City',
  INVALID_CITY_KEY: 'Invalid city',
  COUNTRY_KEY: 'Country',
  STATE_KEY: 'State',
  ZIP_KEY: 'Zip',
  INVALID_ZIP_KEY: 'Invalid zip code',
  ORDER_NUMBER: 'Order number',
  YOUR_DETAILS_KEY: 'Your details',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  CAUTION_FOR_LAPTOP_SELECTION:
    'For having a PC skin perfectly adapted to yours, you must select the exact model corresponding to the purchase, as it is seen in the invoice.',
  NOTICE_KEY: 'Notice:',
  RESTART_PROJECT_ALERT_TITLE: 'Restart a project ?',
  DISCARD_ALERT_MESSAGE: 'Your current project will be discarded',
  RESTART: 'Restart',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Page Size Warning!',
  MODIFY_SIZE_WARNING:
    'If you wish to resize this design, you can do so in the “Settings” tab. Design elements may require editing to adjust to your desired dimensions.',
  MATERIAL_CHOICE_APPLIED: 'Material choice applied.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'certificate of',
  AUTHENTICITY_STRING: 'authenticity',
  PLEASE_WAIT: 'Please wait',
  PROTECTING_YOUR_DATA: 'protecting your data...',

  SEARCH_YOUR_LAPTOP_KEY: 'Search your laptop', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Oops! We couldn’t find any laptops for your search.', // Google translated
  LOCKED_PROJECT: 'Locked Project',
  LOCKED_MESSAGE:
    'This project has been ordered and cannot be changed. You can view this project only.',
  EXPIRED_PROJECT: 'Expired Project',
  EXPIRED_MESSAGE: 'This project has expired.',
  DELETED_PROJECT: 'Deleted Project',
  DELETED_MESSAGE: 'This project has been deleted.',
  CHOOSE_GROUP_TYPE: 'Choose {0} type',
  MASK_LEGAL_TEXT:
    'Disclaimer - By using this app, you acknowledge that HP and its affiliates make no representation as to the safety and efficacy of any product created from the Designs.',
  MASK_LEGAL_DETAILED_TEXT:
    '   Disclaimer - By using any of the indicated Designs, you acknowledge that:\n\n   • All Designs have been created by HP and its partners in response to the global COVID-19 pandemic;\n\n    • HP and its partners have no prior expertise in the designing and manufacturing of Personal Protective Equipment (PPE), and therefore this Design has neither been made by reference to any specific regulations nor subject to any formal testing regime;\n\n  • Any user of the Designs shall assume all responsibility for developing the design in conformity with regulatory and testing requirements of any markets it intends to make the products available in;\n\n    • To remove any doubt, the Designs are provided AS-IS, and HP and its affiliates shall not be liable for any loss or damage to users or any other third parties related to the use caused as a result of the Designs. The Designs are for professional use only and neither HP nor its affiliates make any representations, guarantees, or warranties of any kind with respect to the Designs or their use. The Designs may not be used for any unlawful purposes. Given the exigent circumstances under which these Designs are being provided, HP and its affiliates make no representation as to the safety and efficacy of any product created from the Designs.',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Please enter numbers above zero.',
  SIZE_KEY: 'Size',
  DISTANCE_FROM_KEY: 'Distance from',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Left',
  RIGHT_KEY: 'Right',
  DELETE_WALL_KEY: 'Delete a wall',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Rows',
  COLUMNS_KEY: 'Columns',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'Edit',
  TOP_KEY: 'Top',
  BOTTOM_KEY: 'Bottom',
  WALL_COVERING_SIZE: 'Wallcovering size'
};
